import { useQuery } from '@tanstack/react-query';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { getFileProcessingStatus } from './getFileProcessingStatus';
import { FileProcessingStatus } from './types';

type Props = {
  companyId: string
  fileId: string
  taskId: string
  disabled?: boolean
  onDone?: () => void
  intervalMs?: number
}

const QUERY_KEY_PROCESSING_FILE_STATUS = 'QUERY_KEY_PROCESSING_FILE_STATUS'

/**
 * Fetches available countries.
 */
export function useUploadStatusPooling(props: Props) {
  const { companyId, fileId, taskId, disabled, onDone, intervalMs = 5000 } = props
  return useQuery<FileProcessingStatus>({
    queryKey: [QUERY_KEY_PROCESSING_FILE_STATUS, companyId, fileId, taskId],
    queryFn: async () => {
      const { data } = await getFileProcessingStatus(props);
      if(onDone && data.isProcessing === false){
        onDone()
      }
      return data;
    },
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
    refetchInterval: (query) => {
      // v5 podaje tu obiekt Query, dane są w query.state.data
      const data = query.state.data
      if(!data || disabled || data.isProcessing === false){
        return false
      }
      return intervalMs;
    },
    enabled: !disabled && Boolean(companyId) && Boolean(fileId) && Boolean(taskId)
  });
}
